module.exports = __webpack_public_path__ + "img/89.02834482.png";